<script setup>
import { computed } from "vue";
import { storeToRefs } from "pinia";

const props = defineProps({
  historialDeOfertas: Object, // tu store de Pinia
  puja: Object,               // viene con { id, lote:{ id, facturacion_id } }
});

const store = props.historialDeOfertas;
const { datos_facturacion, selected_tab } = storeToRefs(store);

// Siempre busco la puja "viva" en el store por ID (si la lista se reemplaza, esto se actualiza)
const pujaFromStore = computed(() =>
  (selected_tab.value?.listado ?? []).find(p => p.id === props.puja.id)
);

// v-model del <select>: lee del store y escribe al store
const facturacionId = computed({
  get() {
    const v = pujaFromStore.value?.lote?.facturacion_id ?? null;
    return v == null ? "" : String(v); // <select> usa strings
  },
  set(raw) {
    const loteId = pujaFromStore.value?.lote?.id;
    const val = raw === "" ? null : Number(raw);
    if (loteId != null) store.asignarIdPerfilFacturacionALote(loteId, val);
  },
});
</script>

<template>
  <select class="form-select form-select-sm rounded-2 border-soft-grey" v-model="facturacionId">
    <option value="">No Seleccionado</option>
    <option v-for="dato in datos_facturacion" :key="dato.id" :value="String(dato.id)">
      {{ dato.cuit_cuil }}
    </option>
  </select>
</template>

<style scoped>
.form-select { font-size: smaller !important; }
</style>
